export const normalizeIdentifier = (text) => {
    return text
        .toLowerCase()
        .replaceAll("å", "a")
        .replaceAll("ä", "a")
        .replaceAll("ö", "o")
        .replace(/[^a-zA-Z0-9]+/g, "")
        .trim();
};
//# sourceMappingURL=normalize.js.map